import { render, staticRenderFns } from "./vehicleFitness.vue?vue&type=template&id=67624746"
import script from "./vehicleFitness.vue?vue&type=script&lang=js"
export * from "./vehicleFitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports